import useProductCardActions from '@components/Product/hooks/useProductCardActions';
import { SaleItemType } from '@components/Search/interfaces/product-action.dto';
import useSharedEntities from '../../../../../../shared-entities/hooks/useSharedEntities';
import { useRachelPresentation } from '../../../../../hooks/useRachelPresentation';
import { useRachelStore } from '../../../../../store/rachel.store';
import { selectCloseRachel } from '../../../../../store/rachel.store.selectors';
import { ProductCardsBlockItem } from '../../productCardsBlock.types';
import { ProductCardsColorsConfig, ProductCardsPriceConfig } from '../../productCardsBlock.types';
import { findColorOption, toColorOptions, toRendererPrices } from '../../productCardsBlock.utils';

export const useProductCardsBlockItem = (product: ProductCardsBlockItem) => {
  const { isShopping, loading, onClickShopping, openDetails, disableProductDetails } =
    useProductCardActions({
      entityRelations: {
        type: SaleItemType.PRODUCT_COLOR,
        productId: product.productId,
        productColorId: product.productColorId,
      },
    });
  const { shouldDisableAllPrices, disableRetailPrice, disableWholesalePrice } = useSharedEntities(
    {},
  );
  const presentation = useRachelPresentation();
  const closeRachel = useRachelStore(selectCloseRachel);

  const openDetailsFromChat = (productColorId?: string) => {
    if (presentation.isOverlaid && !disableProductDetails) {
      closeRachel();
    }

    openDetails(productColorId);
  };

  const colorOptions = toColorOptions(product.colors);

  const colors: ProductCardsColorsConfig = {
    options: colorOptions,
    selected: findColorOption(colorOptions, product.productColorId),
    onSelect: (productColorId) => openDetailsFromChat(productColorId),
  };

  const price: ProductCardsPriceConfig = {
    prices: toRendererPrices(product.prices),
    isVisible: !shouldDisableAllPrices,
    isRetailDisabled: Boolean(disableRetailPrice),
    isWholesaleDisabled: Boolean(disableWholesalePrice),
  };

  return {
    colors,
    price,
    shopping: { isShopping, isLoading: loading, onClick: onClickShopping },
    onOpenDetails: () => openDetailsFromChat(),
  };
};
